import { useActivation } from '@context/MobileOne';
import { FeedbackImage, ScrollToTop } from '@core/index';
import { replaceDynamicCmsContent, tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';

export const VoucherSuccess = () => {
  const { nextStep, setShowActivationHeader, setStep4SubStep, withVoucher, voucherGBNo } =
    useActivation();

  // Const

  let imageContent = {};
  let headerContent = {};
  let copyTextContent = {};
  let buttonContent = {};

  if (withVoucher) {
    imageContent = useCmsImage('ek_reg_voucher_suc_web_bg');
    headerContent = tA11y('ek_reg_voucher_suc_hdl1');
    headerContent = replaceDynamicCmsContent(headerContent, '{BONUS}', voucherGBNo);
    copyTextContent = tA11y('ek_reg_voucher_suc_txt1');
    buttonContent = tA11y('ek_reg_voucher_suc_btn1');
  } else {
    imageContent = useCmsImage('ek_reg_without_voucher_suc_web_bg');
    headerContent = tA11y('ek_reg_without_voucher_hdl1');
    copyTextContent = tA11y('ek_reg_without_voucher_txt1');
    buttonContent = tA11y('ek_reg_without_voucher_btn1');
  }

  return (
    <>
      <ScrollToTop>
        <FeedbackImage
          image={imageContent}
          icon={withVoucher ? appIconsPath.GESCHENKEWAGEN : appIconsPath.INFO_MESSAGE}
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => {
            nextStep();
            setStep4SubStep(0);
            setShowActivationHeader(true);
          }}
        />
      </ScrollToTop>
    </>
  );
};

export default VoucherSuccess;
